import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface EventPayload {
    nombre: string;
    data: any;
}


@Injectable({
    providedIn: 'root'
})
export class EmitEventService {
    private eventComponent$ = new Subject<any>();

    ejecutarAccion(row: any, nombre: string) {
        this.eventComponent$.next({ nombre, valor: row });
    }

    obtenerAccion() {
        return this.eventComponent$.asObservable();
    }

    private eventos$ = new Subject<EventPayload>();

    emit(nombre: string, data: any): void {
        this.eventos$.next({ nombre, data });
    }

    on<T>(nombre: string): Observable<T> {
        return this.eventos$.pipe(
            filter(evento => evento.nombre === nombre),
            map(evento => evento.data as T)
        )
    }

}